import { Component } from 'react';
import { connect } from 'react-redux';

import { evAddOrEditAddress } from 'events/account';
import OrderCareBillingAddressCard from 'components/account/Order/OrderCareBillingAddressCard';
import ShippingForm from 'components/account/ShippingForm';
import { SmallLoader } from 'components/Loader';
import { saveNewBillingAddress } from 'actions/account/order';
import { makeFormErrorMessage } from 'helpers/MyAccountRenderUtils';
import { resetShippingForm, updateMailingAddressOrName, updateShippingPhone } from 'actions/account/shipping';
import { titaniteView, track } from 'apis/amethyst';

import css from 'styles/components/account/orderCareAddNewBillingAddress.scss';

export class OrderCareAddNewBillingAddress extends Component {
  componentDidMount() {
    titaniteView();
  }

  onSaveBillingAddress = () => {
    const {
      shipping: { address }
    } = this.props;
    const {
      saveNewBillingAddress,
      ccStateInstrumentData,
      order: { suggestedAddresses }
    } = this.props;
    Promise.resolve(saveNewBillingAddress(address, ccStateInstrumentData, suggestedAddresses?.length)).then(response => {
      if (response?.addressId) {
        const { addressId, valid } = response;
        track(() => [evAddOrEditAddress, { valid, addressId, addressType: 1 }]); // amethyst addressType 1 => billing
      }
    });
  };

  onSelectSuggestedAddress = e => {
    const {
      order: { suggestedAddresses },
      updateMailingAddressOrName
    } = this.props;
    // index of suggested address set as id of radio input; let's use that to fetch correct address in state
    const suggestedAddressIndex = e.currentTarget.id.split('_')[1];
    updateMailingAddressOrName({
      suggestedAddress: suggestedAddresses[suggestedAddressIndex].mailingAddress
    });
  };

  makeSuggestedAddresses = (suggestedAddresses, newAddressId) => {
    const {
      shipping: {
        address: { mailingAddress }
      }
    } = this.props;
    const addresses = [];
    suggestedAddresses.map((address, i) => {
      const inputId = `${newAddressId}_${i}`;
      addresses.push(
        <OrderCareBillingAddressCard
          key={inputId}
          address={address}
          onSelectBillingAddress={this.onSelectSuggestedAddress}
          inputId={inputId}
          inputName="suggestedAddress"
          isRequired={false}
          currentAddress={mailingAddress}
        />
      );
    });
    return (
      <div className={css.suggestedAddresses}>
        <p className={css.suggestedAddressesMsg}>
          <strong>We have a suggestion</strong> for your address. For accurate delivery, consider the change below.
        </p>
        {addresses}
      </div>
    );
  };

  render() {
    const {
      order: { isAddNewBillingAddressUpdating, addNewBillingAddressError, addNewBillingAddressErrorDetails, suggestedAddresses, newAddressId },
      shipping,
      onCancelAddNewAddress,
      updateMailingAddressOrName,
      updateShippingPhone,
      resetShippingForm
    } = this.props;

    if (isAddNewBillingAddressUpdating) {
      return <SmallLoader />;
    }
    return (
      <div className={css.wrap}>
        <h2 className="zappos:body-l-bold">New Payment Information</h2>
        {addNewBillingAddressError && <div className={css.errorMsg}>{makeFormErrorMessage(addNewBillingAddressErrorDetails)}</div>}
        {suggestedAddresses && this.makeSuggestedAddresses(suggestedAddresses, newAddressId)}
        <ShippingForm
          isReducedInfo={true}
          primaryVerbiage="Save Address"
          shipping={shipping}
          onChangeShippingAddress={this.onSaveBillingAddress}
          onUpdateMailingAddressOrName={updateMailingAddressOrName}
          onUpdateShippingPhone={updateShippingPhone}
          onCancelClick={onCancelAddNewAddress}
          onResetShippingForm={resetShippingForm}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  order: state.order,
  shipping: state.shipping
});

export default connect(mapStateToProps, {
  saveNewBillingAddress,
  updateMailingAddressOrName,
  resetShippingForm,
  updateShippingPhone
})(OrderCareAddNewBillingAddress);
